function isSitefinityEditor() {
  return $("body").hasClass("sfPageEditor") || typeof sitefinity === "object";
}

/**********************************************************************************************************************/
// region Home Page (Hero section) */
/**********************************************************************************************************************/

if (!isSitefinityEditor() && $("body").hasClass("homePage")) {
  ScrollSmoother.create({
    wrapper: ".smooth-scroller",
    content: ".smooth-content",
    smooth: 1.5,
    effects: true
  });
}
if (!isSitefinityEditor()) {
  initHomePageHeroAnimation();
}
function initHomePageHeroAnimation() {
  var heroTimeline = gsap.timeline();
  var $overlay = $(".hero-overlay");
  heroTimeline.to($overlay[0], {
    height: "0%",
    duration: 1,
    ease: "herooverlay"
  });
  heroTimeline.from($(".hero")[0], {
    opacity: 0,
    duration: 1
  }, "<");
  heroTimeline.add("letters", ">-=0.3");
  $("svg .word").each(function () {
    var $word = $(this);
    var chars = $word.find("g");
    heroTimeline.from(chars, {
      duration: .8,
      //opacity: 0,
      //y: "150%",
      y: $(".title-animation-container").outerHeight(),
      //transformOrigin: "0% 50% -50",
      //ease: "back",
      stagger: 0.05,
      //ease: "letters",
      ease: "power2.out"
    }, "letters");
  });
}

/**********************************************************************************************************************/
/* #region Home Page (horizontal scroller section) */
/**********************************************************************************************************************/

if (!isSitefinityEditor() && $("body").hasClass("homePage")) {
  initHomePageScrollerSection();
}
function initHomePageScrollerSection() {
  const container = document.querySelector(".scroll-container");
  const panels = gsap.utils.toArray(".scroll-container .panel");
  const allTitles = gsap.utils.toArray(".scroll-container .panel-inner .panel-title-wrap");

  // Exclude the first matching element
  const firstTitle = allTitles.shift(); // Remove and store the first element
  const titles = allTitles; // Remaining titles

  // the end value for the scroll trigger
  const end = () => "+=" + (container.offsetWidth - window.innerWidth) * 0.3; // the last value is a multiplier to adjust the scroll speed

  // a shared scroll trigger for the non-pinned elements
  const nonPinnedScrollTrigger = {
    trigger: ".scroll-container",
    pin: false,
    scrub: true,
    start: "top top",
    end: end
  };

  // the exit tween for the first title (slide up and right to oppose scrolling)
  let firstTitleExitTween = gsap.to(firstTitle, {
    yPercent: () => -100,
    x: () => `${(panels.length - 1) * 100}vw`,
    ease: "none",
    //opacity: 0.1,
    scrollTrigger: nonPinnedScrollTrigger
  });

  // fade-in and slide-in the titles
  let titleTween2 = gsap.from(titles, {
    xPercent: () => -60,
    ease: "none",
    opacity: 0.1,
    scrollTrigger: nonPinnedScrollTrigger
  });

  // scroll the panels horizontally
  let panelScrollTween = gsap.to(panels, {
    x: () => `-${(panels.length - 1) * 100}vw`,
    ease: "none",
    scrollTrigger: {
      trigger: ".scroll-container",
      pin: true,
      scrub: true,
      start: "top top",
      snap: {
        snapTo: 1 / (panels.length - 1),
        inertia: false,
        ease: "power1.inOut"
      },
      end: end
    }
  });

  // fade in all panels (except for the first one)
  const firstPanel = panels.shift();
  let panelEntranceTween = gsap.from(panels, {
    ease: "none",
    opacity: 0,
    scrollTrigger: nonPinnedScrollTrigger
  });
}